module.exports = __webpack_public_path__ + "static/media/world.9d27c902.jpeg";